module.exports = [{
      plugin: require('../node_modules/.pnpm/gatsby-plugin-google-gtag@2.8.0_gatsby@2.32.13_@types+node@25.6.0_@types+react@17.0.91__c9316eaf362370071f1e0d5c544c07c1/node_modules/gatsby-plugin-google-gtag/gatsby-browser.js'),
      options: {"plugins":[],"trackingIds":["G-2K3PH6MKBG"]},
    }]
